module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    staticClass: "mt-10 mb-50",
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": {
        minHeight: '830px'
      }
    }
  }, [_c('el-input', {
    staticClass: "mb-10",
    attrs: {
      "placeholder": !_vm.teacherId && _vm.role === 'admin' ? 'Please choose a teacher first' : _vm.searchPlaceHolder,
      "disabled": !_vm.teacherId && _vm.role === 'admin'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClickL.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywordsL),
      callback: function($$v) {
        _vm.keywordsL = $$v
      },
      expression: "keywordsL"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClickL
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingL),
      expression: "loadingL"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": (_vm.role === 'admin' && !_vm.tId) ? 'Please choose a teacher first' : 'No data',
      "data": _vm.AllStudents,
      "border": "",
      "tooltip-effect": "dark",
      "element-loading-text": "loading..."
    },
    on: {
      "selection-change": _vm.AddSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.school,
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPageL,
      "page-count": _vm.totalPagesL
    },
    on: {
      "current-change": _vm.pageCurrentChangeL
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mb-50 actions",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0",
      "min-width": "85px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticClass: "ml-5 mr-5 mb-10",
    staticStyle: {
      "padding": "4px 17px"
    },
    attrs: {
      "disabled": this.Addlist.length === 0 || _vm.addBtnIsLoading,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addRelation
    }
  }, [_vm._v("Add"), _c('i', {
    staticClass: "el-icon-arrow-right el-icon--right pl-10"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "pl-10 pr-10",
    staticStyle: {
      "padding": "4px 17px",
      "margin": "0 5px"
    },
    attrs: {
      "disabled": this.Removelist.length === 0 || _vm.removeBtnIsLoading,
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.removeRelation
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left el-icon--left pr-10"
  }), _vm._v("Remove")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mt-10 mb-50",
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    attrs: {
      "body-style": {
        minHeight: '830px'
      }
    }
  }, [_c('el-input', {
    staticClass: "mb-10",
    attrs: {
      "placeholder": !_vm.teacherId && _vm.role === 'admin' ? 'Please choose a teacher first' : _vm.searchPlaceHolder,
      "disabled": !_vm.teacherId && _vm.role === 'admin'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClickR.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywordsR),
      callback: function($$v) {
        _vm.keywordsR = $$v
      },
      expression: "keywordsR"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClickR
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingR),
      expression: "loadingR"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "empty-text": (_vm.role === 'admin' && !_vm.tId) ? 'Please choose a teacher first' : 'No data',
      "data": _vm.MyStudents,
      "border": "",
      "tooltip-effect": "dark",
      "element-loading-text": "loading...",
      "max-height": "641"
    },
    on: {
      "selection-change": _vm.RemoveSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.school,
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mt-20 mb-50",
    attrs: {
      "span": 2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327f6f69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/TransferBox.vue
// module id = 606
// module chunks = 1